import { StepsEnum } from '../types';
export { StepsEnum as CheckoutSteps } from '../types';
export var MobileStepbarMode;
(function (MobileStepbarMode) {
    MobileStepbarMode[MobileStepbarMode["Checkout"] = 0] = "Checkout";
    MobileStepbarMode[MobileStepbarMode["Checkin"] = 1] = "Checkin";
})(MobileStepbarMode || (MobileStepbarMode = {}));
